<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <div class="all_page_border">

        <div style="padding-left: 5px">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="学生" name="0">
              <!--工具条-->
              <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            </el-tab-pane>
            <el-tab-pane label="教师" name="1">
              <!--工具条-->
              <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar> -->
        <!--列表-->
        <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange" ref="table"
          style="width: 100%" class="custom-tbl" v-if="users">
          <el-table-column type="selection" width="50"></el-table-column>
          <!-- <el-table-column type="index" width="80"></el-table-column> -->
          <el-table-column prop="UserName" label="姓名" width></el-table-column>
          <el-table-column prop="CardNo" label="卡号" width></el-table-column>
          <el-table-column prop="DeptName" label="部门" width></el-table-column>
          <el-table-column prop="RechargeMoney" label="充值金额" width></el-table-column>
          <el-table-column prop="TotalMoney" label="消费金额" width></el-table-column>
          <el-table-column prop="DiscountMoney" label="补贴金额" width></el-table-column>
          <el-table-column prop="PayMoney" label="实际消费金额" width></el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
            style="float: right"></el-pagination>
        </el-col>
      </div>

    </section>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getPowerUserConsumptionSummary, exportPowerUserConsumptionSummary } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      activeName: "0",
      filters: {
      },
      searchList: [
        {
          label: '姓名',
          key: 'name',
        }, {
          label: '开始日期',
          key: 'date',
          type: 'date'
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date'
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      dialogVisible: false,
      currentDate: "",
      historyData: [],
      historyDataTotal: 0,
      historyDataPage: 1,
      historyUserId: 0,
      multipleSelection: [],

      refundDialogVisible: false,
      refundData: [],
      refundDataTotal: 0,
      refundDataPage: 1,

    };
  },
  computed: {
  },
  methods: {
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    handleClick(tab, event) {
      this.page = 1;
      this.handleQuery();
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },
    callFunction(item) {
      this.currentDate = item.search.date || "";
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: this.activeName
      };
      this.listLoading = true;
      //NProgress.start();
      getPowerUserConsumptionSummary(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },

    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
          type: this.activeName
        };

        var fileName = this.activeName == 0 ? "学生消费汇总报表" : "教师消费汇总报表";
        const response = await exportPowerUserConsumptionSummary(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

</style>
